import { useCategoryPageFilterKeys } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useRequestReferrer } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useRequestReferrer";
import { useRequestPageSize } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/__internal__/useRequestPageSize";
import { useCategoryPageQueryKeys } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQueryKeys";
import { useShowProductFirstResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/useShowProductFirstResults/useShowProductFirstResults";
import { useCurrentNavigationPath } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";
import { useOneIndexedPageNumber } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useOneIndexedPageNumber";
export var useCategoryPageRequestParams = function(pageNumber) {
    var showProductFirstResults = useShowProductFirstResults();
    var navigationPath = useCurrentNavigationPath();
    var filterKeys = useCategoryPageFilterKeys();
    var requestPageSize = useRequestPageSize();
    var oneIndexedPageNumber = useOneIndexedPageNumber();
    var requestPageNumber = pageNumber !== null && pageNumber !== void 0 ? pageNumber : oneIndexedPageNumber;
    var requestReferrer = useRequestReferrer();
    var queryKey = useCategoryPageQueryKeys(requestPageNumber);
    var fetchResultsOptions = {
        showProductFirstResults: showProductFirstResults,
        navigationPath: navigationPath,
        filterKeys: filterKeys,
        requestPageSize: requestPageSize,
        oneIndexedPageNumber: requestPageNumber,
        requestReferrer: requestReferrer
    };
    return {
        queryKey: queryKey,
        fetchResultsOptions: fetchResultsOptions
    };
};
